import { Col, Button } from "react-bootstrap";

import { GrAddCircle } from "react-icons/gr";

const ActivitiesCard = ({ title, description, img }) => {
  return (
    <Col md={4} className="my-2">
      <div className=" shadow rounded p-3">
        <img src={img} alt="img" className="img-fluid rounded" />

        <div className="hiddenOnDrag">
          <h5 className="pt-3">{title}</h5>
          <div className="d-flex justify-content-around">
            <div>
              <p>{description}</p>
            </div>
            <div className="d-flex justify-content-end align-items-end align-content-end">
              <GrAddCircle size="1.5em" className="m-2" />
            </div>
          </div>
        </div>
      </div>
    </Col>
  );
};

export default ActivitiesCard;
